import { setIsMobile, useAssets, useMobile } from "../../../hooks";
import Step from "./Step.js";
import { useConfig } from "../../../hooks/useConfig.js";

import {
  fetchData,
  postData,
  putData,
  deleteData,
  fetchBlobData,
} from "../../../endpoints";
import { useEffect, useState, useRef } from "react";
import { Button, Modal, Spin, Image, Select } from "antd";
import { Card } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomInput } from "../../../components/CustomInput/index.js";
import Documents from "../document";
import access from "../../../assets/access";
import Cookies from "js-cookie";
import full from "../../../assets/fullAccess";
import AddComment from "../../ToDo/comment/addComment.js";
import Payment from "./Payment.js";
import CommentCard from "../../ToDo/comment/commentCard.jsx";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Table, Input, Space } from "antd";
import { SearchOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const privilage = Cookies.get("privilege") ?? full;
const ServicePage = ({
  current,
  setIsOpen,
  patientId,
  isPurchase = false,
  fetchService,
  name,
  mrn,
  patient,
  setIsPurchase,
  tempStep = null,
  url,
}) => {
  const { getFile } = useAssets();
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const { confirm } = Modal;
  const [service, setService] = useState(current);
  const [loading, setLoading] = useState(true);
  const [thisPurchase, setThisPurchase] = useState(isPurchase);
  const [email, setEmail] = useState("");
  const [needUpdate, setNeedUpdate] = useState([]);
  const [totalPrice, setTotalPrice] = useState("");
  const [payedPrice, setPayedPrice] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [select, setSelect] = useState({});
  const [openComments, setOpenComments] = useState(false);
  const [isOpenAssign, setisOpenAssign] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [selectedRowKeysadmin, setSelectedRowKeysadmin] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [myservice, setMyService] = useState(
    isPurchase ? current.service : current
  );
  const UserId = localStorage.getItem("id");
  const [paymentOptions, setPaymentOptions] = useState([]);
  const { getUserConfig } = useConfig();
  const [defult, setDefult] = useState({
    patientId: patientId,
    purchaseId: parseInt(service.id),
    patient: patient,
  });
  const [isPayment, setIsPayment] = useState(false);
  const [openPayModal, setOpenPayModal] = useState(false);
  const isMobile = useMobile();
  const [paymentType, setPaymentType] = useState("");
  const [payments, setPayments] = useState([]);
  const [onlinePaymentLink, setOnlinePaymentLink] = useState("");
  const [showCopyOnlinePaymentLink, setShowCopyOnlinePaymentLink] =
    useState(false);
  const [showCopyOnlinePaymentText, setShowCopyOnlinePaymentText] =
    useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const getOptions = async () => {
    getUserConfig();
    var res = JSON.parse(localStorage.getItem("config"));
    setPaymentOptions(res.data.data.payment.method);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  function download(data) {
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.download =
      patient.firstName + patient.lastName + "_" + service.id + ".pdf";
    a.href = url;
    a.target = "_blank";

    a.click();

    setTimeout(function () {
      a.remove();
      URL.revokeObjectURL(url);
    }, 100);
  }
  const invoice = async () => {
    setLoading(true);
    var res = await fetchBlobData(
      "admin/service-purchase/" + service.id + "/invoice"
    );
    if (res.status == 200) {
      download(res.data);
    } else {
      Modal.error({ title: res });
    }
    setLoading(false);
  };
  useEffect(() => {
    const savedState = sessionStorage.getItem("modalState");
    if (savedState) {
      setModalData(JSON.parse(savedState));
      setIsModalVisible(JSON.parse(savedState).showModal);
      sessionStorage.removeItem("modalState");
    }
  }, []);
  const getTotalPrice = async (steps) => {
    var tP = 0;
    var pp = 0;
    var temp = [];
    steps.map((s) => {
      if (s.type == "payment") {
        if (s.status == "done") {
          pp += s.price;
        }
        tP += s.price;
        temp = [...temp, s];
      }
    });
    setTotalPrice(tP);
    setPayedPrice(pp);
    setPayments(temp);
  };

  const getSelected = () => {
    var pric = 0;

    selectedPayments.map((s) => {
      pric += s.price;
    });

    return pric;
  };
  const [users, setUsers] = useState([]);
  if (service.steps) {
    var progress = 0;
    // console.log(service.steps);
    service.steps &&
      service.steps.map((temp) => {
        if (temp.status == "done") {
          progress = progress + 1;
        }
      });

    progress = (progress / service.steps.length) * 100;
  }
  const [adminsOnPurchase, setAdminsOnPurchase] = useState([]);
  const [internalLoadnig, setInternalLoading] = useState(false);
  const searchInput = useRef(null);

  const getAdmins = async (page = 1, reload = false) => {
    var temp = admins;
    if (reload) {
      temp = [];
    }
    setLoading(true);
    if (admins.length < (page - 1) * 15 + 2 || reload) {
      var res = await fetchData(
        "admin/user/?disabledAt=false&deletedAt=false&perPage=15&type[]=admin&type[]=super_user&page=" +
          page
      );
      if (res.status === 200) {
        if (res.data.data.length < 15) {
          setAdmins(
            temp
              .filter((a, i) => {
                return a.firstName;
              })
              .concat(res.data.data)
          );
        } else {
          setAdmins(
            temp
              .filter((a, i) => {
                return a.firstName;
              })
              .concat([...res.data.data, {}])
          );
          console.log(
            temp
              .filter((a, i) => {
                return a.firstName;
              })
              .concat([...res.data.data, {}])
          );
        }
      } else {
        Modal.error({ title: res });
      }
    }
    setLoading(false);
  };
  const getAdminsOnPurchase = async (purchaseId) => {
    setInternalLoading(true);
    var res = await fetchData(
      `admin/user-assignment?itemType=purchase&includes[]=user&deletedAt=false&itemId=` +
        purchaseId
    );
    if (res.status == 200) {
      setAdminsOnPurchase(
        res.data.data.map((item) => {
          if (item.user)
            return {
              ...item,
              name: item.user.firstName + " " + item.user.lastName,
              email: item.user.email,
            };
          else {
            return { ...item, name: item.userId };
          }
        })
      );
      getAssinees(UserId);
    }
    setInternalLoading(false);
  };
  const chekout = async () => {
    setLoading(true);
    var res = await putData(`admin/service-purchase/${service.id}/checkout`, {
      purchaseSteps: selectedPayments.map((s) => {
        return s.id;
      }),
      method: paymentType,
      successUrl: `https://cpanel-stg.allbrainsclinic.com/+${pathname}`,
      cancelUrl: `https://cpanel-stg.allbrainsclinic.com/+${pathname}`,
    });
    if (res.status != 200) {
      Modal.error({ title: res });
      setLoading(false);
      return;
    }
    if (paymentType == "online") {
      setShowCopyOnlinePaymentLink(true);
      // console.log(res.data.data.checkoutUrl);
      setOnlinePaymentLink(res.data.data.checkoutUrl);
      setLoading(false);

      return;
    }
    await fetchType();
    setOpenPayModal(false);
    setLoading(false);
  };
  const getColumnSearchPropsadmin = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={
          isMobile
            ? { padding: 4 }
            : {
                padding: 8,
              }
        }
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearchadmin(selectedKeys, confirm, dataIndex)
          }
          style={
            isMobile
              ? {
                  marginBottom: 2,
                  display: "block",
                  padding: 1,
                  fontSize: "10px",
                }
              : {
                  marginBottom: 8,
                  display: "block",
                }
          }
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearchadmin(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={
              isMobile
                ? {
                    width: "auto",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "10px",
                    padding: "4",
                  }
                : {
                    width: 90,
                  }
            }
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleResetadmin(clearFilters)}
            size="small"
            style={
              isMobile
                ? {
                    width: "auto",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "10px",
                    padding: "4",
                  }
                : {
                    width: 90,
                  }
            }
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
            style={
              isMobile
                ? {
                    width: "auto",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "10px",
                    padding: "4",
                  }
                : {
                    width: 90,
                  }
            }
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearchadmin = async (selectedKeys, confirm, dataIndex) => {
    setLoading(true);
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    if (selectedKeys.length === 0) {
      setAdmins([]);
      await getAdmins();
    } else {
      let search = "";
      if (dataIndex == "type") search = "type";
      if (dataIndex == "email") search = "email";
      if (dataIndex == "name") search = "firstName";

      var res = await fetchData(
        `admin/user/?disabledAt=false&deletedAt=false&perPage=4000&type[]=admin&type[]=super_user&${search}=` +
          selectedKeys[0]
      );

      if (res.status == 200) {
        setAdmins(res.data.data);
      }
    }
    setLoading(false);
  };
  const handleResetadmin = (clearFilters) => {
    clearFilters();
    setSearchText("");
    getAdmins(1, true);
  };
  const data_admin = admins.map((a, i) => {
    return { ...a, key: a.id, name: a.firstName + " " + a.lastName };
  });
  const columns_admin = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // width: "20%",
      ...getColumnSearchPropsadmin("name"),
      render: (u) => <div>{u ? u : "name not provide"}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      // width: "30%",
      ...getColumnSearchPropsadmin("email"),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      // width: "20%",
      ...getColumnSearchPropsadmin("type"),
    },
  ];
  const showRemoveConfirm = async (a) => {
    confirm({
      title: "Are you sure you want to unassign this assignment?",
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        removeAssign(a);
      },
      onCancel() {},
    });
  };
  const getAssinees = async (userId) => {
    var res = await fetchData(
      `admin/user-assignment?deletedAt=false&userId=` + userId
    );
    if (res.status == 200) {
      Cookies.set(
        "assinees_patient",
        res.data.data
          .filter((a) => {
            return a.itemType == "patient";
          })
          .map((p) => {
            return p.itemId;
          })
          .toString()
          .replaceAll(",", " ")
      );
      Cookies.set(
        "assinees_purchase",
        res.data.data
          .filter((a) => {
            return a.itemType == "purchase";
          })
          .map((p) => {
            return p.itemId;
          })
          .toString()
          .replaceAll(",", " ")
      );
    } else {
      Modal.error({ title: res });
    }
  };
  const removeAssign = async (a) => {
    setInternalLoading(true);
    var res = await deleteData("admin/user-assignment/" + a.id);
    if (res.status == 200) {
      getAdminsOnPurchase(service.id);
      Modal.success({ title: res.data.message });
      getAssinees(UserId);
    } else {
      Modal.error({ title: res });
    }
    setInternalLoading(false);
  };
  const rowSelectionadmin = {
    selectedRowKeysadmin,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeysadmin(newSelectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };
  const checkConditions = async () => {
    setLoading(true);
    await fetchType();
    var res = await putData(
      `admin/service-purchase/${current.id}/check-blocking-conditions`
    );
    console.log(res);
    if (res.status != 200) {
      Modal.error({ title: res });
    }
    setLoading(false);
  };
  const fetchType = async (reload = false, id = 0) => {
    setLoading(true);
    var domain = reload
      ? `admin/service-purchase/${id}`
      : thisPurchase
      ? `admin/service-purchase/${service.id}`
      : `admin/service/${service.id}`;
    var res = await fetchData(domain);
    if (res.status == 200) {
      if (reload) {
        setService({
          ...service,
          steps: res.data.data.steps,
          id: id,
          status: res.data.data.status,
        });
      } else
        setService({
          ...service,
          steps: res.data.data.steps,
          status: res.data.data.status,
        });
      getTotalPrice(res.data.data.steps);
      if (isPurchase) {
        setMyService({
          ...myservice,
          types: res.data.data.service.types,
          status: res.data.data.status,
        });
      }
    }
    if (isPurchase || reload) {
      var res2 = await fetchData(`admin/user/${patient.userId}`);
      if (res2.status == 200) {
        setEmail(res2.data.data.email);
      }
    }
    setLoading(false);
  };

  const [comments, setComments] = useState([]);
  const [isopennewcomment, setisopennewcomment] = useState(false);
  const getComments = async () => {
    setLoading(true);
    var res = await fetchData(
      `admin/comment?parentId=0&deletedAt=false&includes[]=watchers&purchaseId=${service.id}&includes[]=reporter&includes[]=assignees&includes[]=attachments&includes[]=replies`
    );
    if (res.status == 200) {
      setComments(res.data.data);
      if (users.length == 0) {
        await getUsers();
      }
    }
    setLoading(false);
  };
  const getUsers = async () => {
    var res = await fetchData(
      `admin/user/?disabledAt=false&deletedAt=false&perPage=100&page=1&type=admin&type=super_user`
    );
    if (res.status == 200) {
      setUsers(res.data.data);
    } else {
      Modal.error({ title: res });
    }
  };
  useEffect(() => {
    getOptions();
    fetchType();
    getAdmins();
    getAdminsOnPurchase(service.id);
  }, []);
  return (
    <div className="d-flex flex-row">
      <div
        style={{ paddingBottom: "75px", paddingRight: "20px" }}
        className={isMobile ? "" : 'col-12 d-flex flex-column gap-3"'}
      >
        <div className="service-page col-12 d-flex flex-column">
          {!isMobile && (
            <div
              style={{ marginTop: "-10px", marginLeft: "0px" }}
              className="d-flex flex-row gap-2 align-items-center"
            >
              <svg
                onClick={() => {
                  navigate("/patients/" + patientId + "/services");
                  setIsOpen(false);
                }}
                width="24"
                height="18"
                viewBox="0 0 24 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.8016 8.39557H2.6553L10.0228 1.01421C10.2548 0.78219 10.2548 0.40603 10.0228 0.174013C9.79085 -0.0580043 9.41481 -0.0580043 9.18286 0.174013L0.783422 8.57595C0.667448 8.68473 0.601562 8.83691 0.601562 8.99605C0.601562 9.15519 0.667451 9.30737 0.783422 9.41615L9.18286 17.8181C9.2916 17.9341 9.44374 18 9.60283 18C9.76193 18 9.91406 17.9341 10.0228 17.8181C10.1388 17.7093 10.2047 17.5571 10.2047 17.398C10.2047 17.2388 10.1388 17.0867 10.0228 16.9779L2.6553 9.59653H22.8016C23.1329 9.59653 23.4016 9.32781 23.4016 8.99639C23.4016 8.66498 23.1329 8.39625 22.8016 8.39625V8.39557Z"
                  fill="#18324E"
                />
              </svg>
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  paddingTop: "10px",
                  color: "#18324E",
                }}
              >
                Back to all services
              </p>
            </div>
          )}

          <p
            style={
              isMobile
                ? { fontSize: "18px" }
                : {
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "20px",
                    fontWeight: "700",
                  }
            }
          >
            {myservice.title}
            {/* {console.log(thisPurchase)} */}
            <div style={{ fontWeight: "500", fontSize: "16px" }}>
              {isPurchase ? "Purchase ID: " + service.id : <></>}
            </div>
          </p>
          <h3
            className="col-12"
            style={
              isMobile
                ? { fontSize: "16px" }
                : { display: "flex", justifyContent: "space-between" }
            }
          >
            {myservice.types && myservice.types[0].serviceType
              ? myservice.types.map((t, i) => {
                  if (i !== 0) return ", " + t.serviceType.title;
                  else return t.serviceType.title;
                })
              : null}
            <div style={{ fontWeight: "400", fontSize: "14px" }}>
              {isPurchase ? "Purchased at: May 10, 2022" : <></>}
            </div>
          </h3>

          <div className="d-flex flex-row gap-2">
            <div
              className={isPurchase ? "col-9" : "col-12"}
              dangerouslySetInnerHTML={{ __html: myservice.description }}
            />
            {isPurchase && (
              <div className="user-box px-3 py-3">
                {!internalLoadnig ? (
                  <>
                    <div className="col-12">
                      <h3> Assignees: </h3>
                      {adminsOnPurchase.length > 0 ? (
                        adminsOnPurchase.map((a) => {
                          return (
                            <div className="d-flex flex-row my-2 col-12">
                              <h3 className="col-7">{a.name}</h3>
                              <Button
                                // classNames={"col-3"}
                                style={{ position: "absolute", right: "38px" }}
                                type="default"
                                size="small"
                                danger
                                onClick={() => {
                                  showRemoveConfirm(a);
                                }}
                              >
                                Unassign
                              </Button>
                            </div>
                          );
                        })
                      ) : (
                        <div>
                          <h3>No assignees found</h3>
                        </div>
                      )}
                    </div>
                    <div className="line" />
                  </>
                ) : (
                  internalLoadnig && (
                    <div className="align-items-center">
                      <Spin />
                    </div>
                  )
                )}

                <div
                  style={{ bottom: "5px", position: "relative" }}
                  className="d-flex flex-row gap-2"
                >
                  <h2
                    style={{ cursor: "pointer", color: "#2E6CDF" }}
                    onClick={() => {
                      setisOpenAssign(true);
                    }}
                  >
                    Add Assignees
                  </h2>
                </div>
              </div>
            )}
          </div>
          <br />
        </div>

        {!isMobile && (
          <div
            className={`${"col-12"}`}
            style={{ marginBottom: "30px", margin: "auto" }}
          >
            <div
              style={{ height: "206px", borderRadius: "2px" }}
              className={
                isMobile ? "servic-card" : "servic-card d-flex flex-row"
              }
            >
              <LazyLoadImage
                className="col-lg-4"
                effect="blur"
                style={{
                  objectFit: "cover",
                  height: "206px",
                  width: "280px",
                  borderRadius: "2px",
                }}
                width={"100%"}
                placeholderSrc={getFile("noImg")}
                src={
                  myservice.cover
                    ? url + "/" + myservice.cover
                    : getFile("noImg")
                }
              />
              <div className={"service-des py-2 col-8 d-flex flex-row gap-2"}>
                <div className=" col-6 d-flex flex-column gap-2">
                  {!loading && (
                    <h2
                      style={
                        isMobile ? { fontSize: "15px" } : { fontSize: "15px" }
                      }
                    >
                      {isPurchase ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>Paid: ${payedPrice}</div>
                          <div>Debt: ${totalPrice - payedPrice}</div>
                          <div>Total: $ {totalPrice}</div>
                        </div>
                      ) : (
                        <div>Total: $ {totalPrice}</div>
                      )}
                    </h2>
                  )}
                  {thisPurchase ? (
                    <div className={isMobile ? "bar mb-3" : "bar my-1"}>
                      <div
                        className="complate"
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                  ) : null}

                  <h4
                    style={{
                      color: "black",
                      fontWeight: "600",
                      fontSize: "18px",
                      paddingTop: "20px",
                    }}
                  >
                    This package includes:
                  </h4>
                  <div className="d-flex flex-row gap-2 align-items-center">
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.4254 1.33087H13.813V1.63953C13.8136 1.82265 13.8136 2.00614 13.8125 2.18926C13.8077 2.87236 13.3176 3.39405 12.672 3.40352L12.6548 3.40403C12.0027 3.40403 11.5094 2.88411 11.5071 2.19436C11.506 1.8939 11.506 1.60699 11.506 1.33047H9.2974V1.67496C9.29791 1.85412 9.29855 2.03839 9.29625 2.22302C9.28793 2.88512 8.80063 3.39276 8.16284 3.40337L8.14339 3.40389C7.50216 3.40389 6.99629 2.88331 6.9922 2.21918C6.98989 1.92217 6.98874 1.62555 6.98938 1.33032H4.78223V1.40544C4.78171 1.49118 4.78223 1.57627 4.78223 1.66201C4.78274 1.84282 4.78274 2.02312 4.78171 2.20342C4.7757 2.87564 4.28777 3.3916 3.64716 3.40336H3.62566C2.98303 3.40336 2.47856 2.87446 2.47627 2.19857C2.47512 1.8976 2.47512 1.60956 2.47512 1.33058H0.867099C0.391336 1.33058 0.000255932 1.72101 0.000255932 2.19743L0 13.8909C0 14.4501 0.408738 14.8273 0.967938 14.8273H9.12238C8.8827 14.4417 8.6947 14.0213 8.56599 13.5755H3.82081C3.82132 13.5784 3.82132 13.581 3.82132 13.5832L1.24038 13.5904L1.2409 10.1919C1.2409 10.1914 1.24141 10.1914 1.24141 10.1908L1.24154 4.76127C1.24154 4.7518 1.25037 4.74297 1.25984 4.74297H15.0282C15.0371 4.74297 15.046 4.7518 15.046 4.76127V7.43331C15.4924 7.58815 15.9094 7.80388 16.2883 8.0711L16.2884 2.19474C16.2887 1.71832 15.9015 1.33111 15.4253 1.33111L15.4254 1.33087Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M4.1866 1.40513C4.1866 1.66938 4.18826 1.93403 4.18609 2.19827C4.18327 2.54967 3.95332 2.80277 3.6357 2.80854C3.31438 2.81455 3.07188 2.55427 3.07073 2.19623C3.06907 1.66734 3.06868 1.13847 3.07073 0.609703C3.07214 0.256886 3.30146 0.00545852 3.61997 8.5999e-05C3.9427 -0.00541658 4.18379 0.253715 4.18635 0.611767C4.18827 0.876272 4.18686 1.14089 4.1866 1.40516L4.1866 1.40513Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M8.70236 1.42226C8.70211 1.6869 8.70492 1.95116 8.70147 2.21566C8.69712 2.55338 8.46358 2.80353 8.15288 2.80877C7.83501 2.81427 7.58932 2.56141 7.58677 2.2154C7.58306 1.67474 7.58306 1.13421 7.58677 0.593553C7.58933 0.247288 7.83438 -0.00443444 8.15288 0.000184613C8.46192 0.00479122 8.69521 0.256116 8.70147 0.593553C8.70403 0.734572 8.70236 0.875591 8.70236 1.01661C8.70262 1.15199 8.70262 1.28725 8.70236 1.42226Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M13.2188 1.40911C13.2188 1.6676 13.2202 1.92648 13.2186 2.18511C13.216 2.54969 12.9887 2.8042 12.664 2.80908C12.3435 2.81394 12.1041 2.5534 12.103 2.19281C12.1013 1.66391 12.1009 1.13478 12.103 0.605918C12.1044 0.256442 12.3394 0.00229604 12.6562 0.000527038C12.9758 -0.00113651 13.2137 0.249294 13.2179 0.598515C13.2216 0.868651 13.2188 1.13891 13.2188 1.40918L13.2188 1.40911Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M4.85494 12.4355H2.72431C2.46979 12.4355 2.26172 12.2274 2.26172 11.9729V10.5675C2.26172 10.3129 2.46979 10.1049 2.72431 10.1049H4.85494C5.10947 10.1049 5.31754 10.3129 5.31754 10.5675V11.9729C5.31792 12.2273 5.10959 12.4355 4.85494 12.4355Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M4.85494 8.44018H2.72431C2.46979 8.44018 2.26172 8.23211 2.26172 7.97759V6.57215C2.26172 6.31763 2.46979 6.10956 2.72431 6.10956H4.85494C5.10947 6.10956 5.31754 6.31763 5.31754 6.57215V7.97759C5.31792 8.23211 5.10959 8.44018 4.85494 8.44018Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M8.37031 12.1826C8.37031 12.2672 8.37261 12.3514 8.37696 12.4354H7.07822C6.8237 12.4354 6.61523 12.2274 6.61523 11.9725V10.567C6.61523 10.3125 6.82331 10.104 7.07822 10.104H8.81843C8.53025 10.7381 8.37031 11.4413 8.37031 12.1826Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M9.20943 8.44018H7.0788C6.82428 8.44018 6.61621 8.23211 6.61621 7.97759V6.57215C6.61621 6.31763 6.82428 6.10956 7.0788 6.10956H9.20943C9.46396 6.10956 9.67203 6.31763 9.67203 6.57215V7.97759C9.67203 8.23211 9.46395 8.44018 9.20943 8.44018Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M14.025 6.57257V7.19552C13.8192 7.16941 13.6091 7.15624 13.396 7.15624C12.5155 7.15624 11.6879 7.38299 10.9688 7.78082V6.5723C10.9688 6.31778 11.1768 6.10931 11.4317 6.10931H13.5624C13.8166 6.10957 14.025 6.31765 14.025 6.57257Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M16.4992 14.4594C16.4992 14.7817 16.2379 15.043 15.9157 15.043C15.5933 15.043 15.332 14.7817 15.332 14.4594C15.332 14.137 15.5933 13.8759 15.9157 13.8759C16.2379 13.8759 16.4992 14.137 16.4992 14.4594Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M14.7971 15.4903C14.7971 15.7625 14.5765 15.9831 14.3043 15.9831C14.0321 15.9831 13.8115 15.7625 13.8115 15.4903C13.8115 15.2182 14.0321 14.9976 14.3043 14.9976C14.5765 14.9976 14.7971 15.2182 14.7971 15.4903Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M12.828 15.564C12.828 15.8048 12.6329 16 12.392 16C12.1513 16 11.9561 15.8049 11.9561 15.564C11.9561 15.3232 12.1513 15.128 12.392 15.128C12.6329 15.128 12.828 15.3232 12.828 15.564Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M11.0761 14.7617C11.0761 14.9109 10.9552 15.0317 10.8061 15.0317C10.6569 15.0317 10.5361 14.9109 10.5361 14.7617C10.5361 14.6127 10.6569 14.4917 10.8061 14.4917C10.9552 14.4917 11.0761 14.6127 11.0761 14.7617Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M17.418 12.0706C17.418 12.4719 17.359 12.8594 17.2483 13.2248L16.1061 12.8871C16.2038 12.5878 16.2566 12.2683 16.2566 11.9361C16.2566 11.6048 16.2041 11.2854 16.1066 10.9867C15.9136 10.3942 15.5453 9.88108 15.0631 9.50884C15.0491 9.49771 15.035 9.48709 15.0207 9.47621C14.8068 9.31395 14.5655 9.17523 14.3061 9.06865C14.139 9.00045 13.9642 8.94798 13.7846 8.90933L13.7167 8.89449L13.6485 8.88336C13.6034 8.87568 13.5565 8.86736 13.5146 8.86275L13.4501 8.85533C13.4286 8.85277 13.4088 8.84957 13.3801 8.84868L13.3018 8.84407L13.2628 8.84177L13.2427 8.84062L13.2332 8.8401L13.2286 8.83985H13.2247C12.8557 8.82833 12.4828 8.87772 12.1331 8.98982C11.7803 9.10423 11.4507 9.27621 11.1652 9.4917C10.8802 9.70783 10.6369 9.963 10.4486 10.2349C10.3996 10.302 10.3568 10.3716 10.3141 10.4404C10.2931 10.4751 10.2748 10.5101 10.2551 10.5445C10.235 10.5792 10.2172 10.6145 10.2003 10.6494C10.1282 10.7888 10.0722 10.9309 10.0244 11.0685C10.0017 11.1381 9.97818 11.2058 9.96154 11.2738C9.95322 11.3073 9.9426 11.3408 9.93569 11.3743C9.92801 11.4079 9.92085 11.4409 9.91419 11.4742C9.91074 11.4902 9.90703 11.5068 9.90383 11.5223C9.90063 11.5387 9.89807 11.5549 9.89551 11.5713C9.89039 11.6032 9.88515 11.6355 9.88003 11.6665C9.87056 11.7289 9.86569 11.7872 9.85853 11.8454C9.85341 11.9062 9.85047 11.97 9.84675 12.0289L9.8465 12.0404C9.8465 12.0404 9.8465 12.0427 9.84599 12.0427V12.0453L9.84573 12.0663C9.84522 12.0801 9.84522 12.0938 9.84458 12.107C9.84458 12.1345 9.84407 12.1608 9.84458 12.1869C9.84483 12.291 9.85008 12.3871 9.85802 12.4731C9.87376 12.6453 9.89935 12.7798 9.9188 12.8709C9.92827 12.9165 9.93569 12.9483 9.94196 12.9741C9.94798 12.9988 9.95169 13.0113 9.95169 13.0113L9.59248 13.1142C9.59248 13.1142 9.58852 13.1022 9.58071 13.0775C9.57303 13.0548 9.56011 13.0132 9.54603 12.964C9.53055 12.9089 9.51161 12.8389 9.49331 12.7552C9.45466 12.5328 9.43457 12.3043 9.43457 12.0707C9.43457 9.86613 11.2218 8.07935 13.4266 8.07935C14.4199 8.07935 15.3285 8.44225 16.0268 9.0424C16.3337 9.30614 16.6003 9.61569 16.815 9.96081C17.1972 10.5728 17.418 11.2959 17.418 12.0707L17.418 12.0706Z"
                        fill="#5F5F5F"
                      />
                      <path
                        d="M15.1691 10.9748C15.0995 10.8696 14.9955 10.84 14.8834 10.8948C14.7461 10.9621 14.612 11.0407 14.4826 11.1167L14.4505 11.1356C14.239 11.2603 14.0279 11.3855 13.8167 11.5108C13.6923 11.5848 13.5679 11.6587 13.4435 11.7324C13.3498 11.6903 13.2466 11.6682 13.1439 11.6682C12.9974 11.6682 12.8559 11.7121 12.7346 11.7949C12.6987 11.8196 12.6643 11.8476 12.6326 11.8788C12.3829 12.1259 12.3457 12.5161 12.544 12.8064C12.6797 13.005 12.9044 13.1238 13.1451 13.1238C13.2466 13.1238 13.3452 13.1028 13.4377 13.0621C13.4779 13.0446 13.5175 13.0226 13.5552 12.9967C13.7647 12.8537 13.8848 12.6098 13.8714 12.3573C14.0795 12.1772 14.4077 11.8998 14.6724 11.676C14.91 11.4751 15.0975 11.3165 15.1367 11.2807C15.2309 11.1941 15.2424 11.0855 15.1691 10.9748Z"
                        fill="#5F5F5F"
                      />
                    </svg>
                    <h3 style={{ marginTop: "3px" }}>
                      {service.steps ? service.steps.length : 0} Step
                    </h3>
                  </div>
                  {myservice.activeDays && (
                    <div className="d-flex flex-row gap-2 align-items-center">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 6.66713e-05C3.58969 6.66713e-05 0 3.58974 0 8.00003C0 12.4103 3.58969 16 8 16C12.4103 16 16 12.4103 16 8.00003C16 5.24023 14.5986 2.80016 12.4661 1.36204L13.2305 0.381575L10 0.264389L10.9323 3.33339L11.6406 2.42323C13.2849 3.49817 14.4262 5.27285 14.6302 7.33467C14.46 7.34399 14.2999 7.41815 14.1826 7.5419C14.0654 7.66564 14.0001 7.82959 14 8.00003C14.0001 8.17112 14.066 8.33561 14.1841 8.45946C14.3021 8.58331 14.4632 8.65704 14.6341 8.66539C14.3229 11.8216 11.8216 14.3229 8.66537 14.6341C8.65701 14.4632 8.58328 14.3021 8.45943 14.1841C8.33558 14.066 8.17109 14.0001 8 14C7.82891 14.0001 7.66442 14.066 7.54057 14.1841C7.41672 14.3021 7.34299 14.4632 7.33464 14.6341C4.17837 14.3229 1.67714 11.8216 1.36589 8.66539C1.53677 8.65704 1.6979 8.58331 1.81593 8.45946C1.93397 8.33561 1.99987 8.17112 2 8.00003C1.99987 7.82895 1.93397 7.66446 1.81593 7.54061C1.6979 7.41676 1.53677 7.34303 1.36589 7.33467C1.69875 3.95935 4.53519 1.33339 8 1.33339C8.08834 1.33464 8.17605 1.31832 8.25803 1.28538C8.34001 1.25244 8.41462 1.20353 8.47754 1.1415C8.54045 1.07947 8.59041 1.00556 8.6245 0.924053C8.6586 0.842549 8.67616 0.75508 8.67616 0.666731C8.67616 0.578381 8.6586 0.490912 8.6245 0.409408C8.59041 0.327903 8.54045 0.253989 8.47754 0.191959C8.41462 0.12993 8.34001 0.0810228 8.25803 0.0480805C8.17605 0.0151381 8.08834 -0.00118269 8 6.66713e-05ZM7.98958 3.32427C7.813 3.32703 7.64473 3.39974 7.52169 3.52643C7.39866 3.65313 7.33092 3.82346 7.33333 4.00005V7.6667L4.93359 9.46617C4.79201 9.57219 4.69834 9.73011 4.67318 9.90519C4.64803 10.0803 4.69346 10.2582 4.79948 10.3998C4.9055 10.5413 5.06342 10.635 5.2385 10.6602C5.41358 10.6853 5.59149 10.6399 5.73307 10.5339L8.39974 8.53389C8.48265 8.47176 8.54994 8.39116 8.59628 8.2985C8.64261 8.20583 8.66671 8.10364 8.66667 8.00003V4.00005C8.66789 3.91086 8.6512 3.82233 8.61759 3.7397C8.58398 3.65707 8.53413 3.58203 8.47099 3.51902C8.40786 3.456 8.33272 3.4063 8.25003 3.37285C8.16734 3.3394 8.07877 3.32288 7.98958 3.32427Z"
                          fill="#5F5F5F"
                        />
                      </svg>
                      <h3 style={{ marginTop: "3px" }}>
                        {myservice.activeDays} Days
                      </h3>
                    </div>
                  )}
                </div>
                <div
                  className="service-btn col-5 d-flex flex-column-reverse gap-2 mb-3"
                  style={{ marginLeft: "35px" }}
                >
                  {thisPurchase ? (
                    service.status == "done_by_patient" ? (
                      <div className="col-12">
                        {payedPrice == totalPrice && payedPrice != 0 && (
                          <p>
                            <Button
                              type="primary"
                              ghost
                              loading={loading}
                              style={{
                                borderRadius: "3px",
                                fontWeight: "bold",
                                width: "100%",
                              }}
                              onClick={async () => {
                                await invoice();
                              }}
                            >
                              Download Invoice
                            </Button>
                          </p>
                        )}
                        <p>
                          {" "}
                          <Button
                            type="primary"
                            ghost
                            disabled={
                              privilage.indexOf(
                                access.patientManegment.service.done
                              ) <= -1
                            }
                            classNames="my-3"
                            loading={loading}
                            id="done"
                            style={{
                              borderRadius: "3px",
                              fontWeight: "bold",
                              width: "100%",
                            }}
                            onClick={async () => {
                              setLoading(true);
                              var res = await putData(
                                `admin/service-purchase/${service.id}/approve`
                              );
                              if (res.status != 200) {
                                Modal.error({ title: res });
                              } else {
                                Modal.success({
                                  title: "Service done successfully!",
                                });
                                var done = document.getElementById("done");
                                done.style.display = "none";
                              }

                              setLoading(false);
                            }}
                          >
                            {"Done"}
                          </Button>
                        </p>
                      </div>
                    ) : (
                      <div className="col-12">
                        {" "}
                        {payedPrice == totalPrice && payedPrice != 0 && (
                          <p>
                            <Button
                              type="primary"
                              ghost
                              loading={loading}
                              style={{
                                borderRadius: "3px",
                                fontWeight: "bold",
                                width: "100%",
                              }}
                              onClick={async () => {
                                await invoice();
                              }}
                            >
                              Download Invoice
                            </Button>
                          </p>
                        )}
                        {service.status != "cancelled" ? (
                          <p>
                            <Button
                              type="primary"
                              ghost
                              style={{
                                borderRadius: "3px",
                                fontWeight: "bold",
                                width: "100%",
                              }}
                              loading={loading}
                              disabled={
                                privilage.indexOf(
                                  access.patientManegment.service.cancel
                                ) <= -1
                              }
                              onClick={async () => {
                                setLoading(true);
                                var res = await putData(
                                  `admin/service-purchase/${service.id}/cancel`
                                );
                                if (res.status != 200) {
                                  Modal.error({ title: res });
                                } else {
                                  await fetchType(true, service.id);
                                  Modal.success({
                                    title: "Service canceled successfully!",
                                  });
                                }

                                setLoading(false);
                              }}
                            >
                              Cancel Service
                            </Button>
                          </p>
                        ) : (
                          <p>
                            <Button
                              type="primary"
                              ghost
                              style={{
                                borderRadius: "3px",
                                fontWeight: "bold",
                                width: "100%",
                              }}
                              loading={loading}
                              disabled={
                                privilage.indexOf(
                                  access.patientManegment.service.cancelPurchase
                                ) <= -1
                              }
                              onClick={async () => {
                                setLoading(true);
                                var res = await putData(
                                  `admin/service-purchase/${service.id}/resume`
                                );
                                if (res.status != 200) {
                                  Modal.error({ title: res });
                                } else {
                                  await fetchType(true, service.id);
                                  Modal.success({
                                    title: "Service activated successfully.",
                                  });
                                }
                                setLoading(false);
                              }}
                            >
                              Active Service
                            </Button>
                          </p>
                        )}
                        <p>
                          <Button
                            type="primary"
                            ghost
                            loading={loading}
                            style={{
                              borderRadius: "3px",
                              fontWeight: "bold",
                              width: "100%",
                            }}
                            onClick={async () => {
                              await checkConditions();
                            }}
                          >
                            Refresh Service
                          </Button>
                        </p>
                      </div>
                    )
                  ) : (
                    <Button
                      type="primary"
                      ghost
                      classNames="my-3"
                      loading={loading}
                      // disabled={
                      //   privilage.indexOf(
                      //     access.patientManegment.service.purchaseService
                      //   ) <= -1
                      // }
                      style={{
                        borderRadius: "3px",
                        fontWeight: "bold",
                        width: "100%",
                      }}
                      onClick={async () => {
                        setLoading(true);
                        var res = await postData(
                          `admin/service/${service.id}/purchase`,
                          { patientId: patientId }
                        );
                        if (res.status == 201) {
                          Modal.success({
                            title: "Service added successfully!",
                          });
                          navigate(
                            "/patients/" +
                              patientId +
                              "/services/in-progress/" +
                              res.data.data.id
                          );

                          setIsPurchase(true);
                          setThisPurchase(true);
                          setMyService({
                            ...res.data.data,
                            types: service.types,
                            title: service.title,
                            cover: service.cover,
                          });
                          await fetchType(true, res.data.data.id);
                          await fetchService();
                        } else {
                          Modal.error({
                            title: res,
                          });
                        }
                        setLoading(false);
                      }}
                    >
                      {"Add Service"}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {isMobile && (
          <Card
            hoverable
            style={{ width: 340 }}
            cover={
              <LazyLoadImage
                className="col-4"
                effect="blur"
                style={{
                  objectFit: "cover",
                  height: "140px",
                  width: "340px",
                  borderRadius: "4px 4px 0px 0px",
                }}
                width={"100%"}
                placeholderSrc={getFile("noImg")}
                src={
                  myservice.cover
                    ? url + "/" + myservice.cover
                    : getFile("noImg")
                }
              />
              // <Image
              //   className="col-4"
              //   style={{
              //     objectFit: "cover",
              //     height: "140px",
              //     width: "340px",
              //     borderRadius: "4px 4px 0px 0px",
              //   }}
              //   placeholder={<Image preview={false} src={getFile("noImg")} />}
              //   src={
              //     myservice.cover
              //       ? url + "/" + myservice.cover
              //       : getFile("noImg")
              //   }
              // />
            }
          >
            <h2 style={{ fontSize: "15px", fontWeight: "700" }}>$1600</h2>
            {thisPurchase && (
              <div className={isMobile ? "bar mb-3" : "bar my-4"}>
                <div className="complate" />
              </div>
            )}
            <h4
              style={{
                color: "black",
                fontWeight: "700",
                fontSize: "15px",
              }}
            >
              This package includes:
            </h4>
            <div style={{ color: "#9E9E9E" }} className="d-flex flex-row gap-2">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.4254 1.33087H13.813V1.63953C13.8136 1.82265 13.8136 2.00614 13.8125 2.18926C13.8077 2.87236 13.3176 3.39405 12.672 3.40352L12.6548 3.40403C12.0027 3.40403 11.5094 2.88411 11.5071 2.19436C11.506 1.8939 11.506 1.60699 11.506 1.33047H9.2974V1.67496C9.29791 1.85412 9.29855 2.03839 9.29625 2.22302C9.28793 2.88512 8.80063 3.39276 8.16284 3.40337L8.14339 3.40389C7.50216 3.40389 6.99629 2.88331 6.9922 2.21918C6.98989 1.92217 6.98874 1.62555 6.98938 1.33032H4.78223V1.40544C4.78171 1.49118 4.78223 1.57627 4.78223 1.66201C4.78274 1.84282 4.78274 2.02312 4.78171 2.20342C4.7757 2.87564 4.28777 3.3916 3.64716 3.40336H3.62566C2.98303 3.40336 2.47856 2.87446 2.47627 2.19857C2.47512 1.8976 2.47512 1.60956 2.47512 1.33058H0.867099C0.391336 1.33058 0.000255932 1.72101 0.000255932 2.19743L0 13.8909C0 14.4501 0.408738 14.8273 0.967938 14.8273H9.12238C8.8827 14.4417 8.6947 14.0213 8.56599 13.5755H3.82081C3.82132 13.5784 3.82132 13.581 3.82132 13.5832L1.24038 13.5904L1.2409 10.1919C1.2409 10.1914 1.24141 10.1914 1.24141 10.1908L1.24154 4.76127C1.24154 4.7518 1.25037 4.74297 1.25984 4.74297H15.0282C15.0371 4.74297 15.046 4.7518 15.046 4.76127V7.43331C15.4924 7.58815 15.9094 7.80388 16.2883 8.0711L16.2884 2.19474C16.2887 1.71832 15.9015 1.33111 15.4253 1.33111L15.4254 1.33087Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M4.1866 1.40513C4.1866 1.66938 4.18826 1.93403 4.18609 2.19827C4.18327 2.54967 3.95332 2.80277 3.6357 2.80854C3.31438 2.81455 3.07188 2.55427 3.07073 2.19623C3.06907 1.66734 3.06868 1.13847 3.07073 0.609703C3.07214 0.256886 3.30146 0.00545852 3.61997 8.5999e-05C3.9427 -0.00541658 4.18379 0.253715 4.18635 0.611767C4.18827 0.876272 4.18686 1.14089 4.1866 1.40516L4.1866 1.40513Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M8.70236 1.42226C8.70211 1.6869 8.70492 1.95116 8.70147 2.21566C8.69712 2.55338 8.46358 2.80353 8.15288 2.80877C7.83501 2.81427 7.58932 2.56141 7.58677 2.2154C7.58306 1.67474 7.58306 1.13421 7.58677 0.593553C7.58933 0.247288 7.83438 -0.00443444 8.15288 0.000184613C8.46192 0.00479122 8.69521 0.256116 8.70147 0.593553C8.70403 0.734572 8.70236 0.875591 8.70236 1.01661C8.70262 1.15199 8.70262 1.28725 8.70236 1.42226Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M13.2188 1.40911C13.2188 1.6676 13.2202 1.92648 13.2186 2.18511C13.216 2.54969 12.9887 2.8042 12.664 2.80908C12.3435 2.81394 12.1041 2.5534 12.103 2.19281C12.1013 1.66391 12.1009 1.13478 12.103 0.605918C12.1044 0.256442 12.3394 0.00229604 12.6562 0.000527038C12.9758 -0.00113651 13.2137 0.249294 13.2179 0.598515C13.2216 0.868651 13.2188 1.13891 13.2188 1.40918L13.2188 1.40911Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M4.85494 12.4355H2.72431C2.46979 12.4355 2.26172 12.2274 2.26172 11.9729V10.5675C2.26172 10.3129 2.46979 10.1049 2.72431 10.1049H4.85494C5.10947 10.1049 5.31754 10.3129 5.31754 10.5675V11.9729C5.31792 12.2273 5.10959 12.4355 4.85494 12.4355Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M4.85494 8.44018H2.72431C2.46979 8.44018 2.26172 8.23211 2.26172 7.97759V6.57215C2.26172 6.31763 2.46979 6.10956 2.72431 6.10956H4.85494C5.10947 6.10956 5.31754 6.31763 5.31754 6.57215V7.97759C5.31792 8.23211 5.10959 8.44018 4.85494 8.44018Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M8.37031 12.1826C8.37031 12.2672 8.37261 12.3514 8.37696 12.4354H7.07822C6.8237 12.4354 6.61523 12.2274 6.61523 11.9725V10.567C6.61523 10.3125 6.82331 10.104 7.07822 10.104H8.81843C8.53025 10.7381 8.37031 11.4413 8.37031 12.1826Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M9.20943 8.44018H7.0788C6.82428 8.44018 6.61621 8.23211 6.61621 7.97759V6.57215C6.61621 6.31763 6.82428 6.10956 7.0788 6.10956H9.20943C9.46396 6.10956 9.67203 6.31763 9.67203 6.57215V7.97759C9.67203 8.23211 9.46395 8.44018 9.20943 8.44018Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M14.025 6.57257V7.19552C13.8192 7.16941 13.6091 7.15624 13.396 7.15624C12.5155 7.15624 11.6879 7.38299 10.9688 7.78082V6.5723C10.9688 6.31778 11.1768 6.10931 11.4317 6.10931H13.5624C13.8166 6.10957 14.025 6.31765 14.025 6.57257Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M16.4992 14.4594C16.4992 14.7817 16.2379 15.043 15.9157 15.043C15.5933 15.043 15.332 14.7817 15.332 14.4594C15.332 14.137 15.5933 13.8759 15.9157 13.8759C16.2379 13.8759 16.4992 14.137 16.4992 14.4594Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M14.7971 15.4903C14.7971 15.7625 14.5765 15.9831 14.3043 15.9831C14.0321 15.9831 13.8115 15.7625 13.8115 15.4903C13.8115 15.2182 14.0321 14.9976 14.3043 14.9976C14.5765 14.9976 14.7971 15.2182 14.7971 15.4903Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M12.828 15.564C12.828 15.8048 12.6329 16 12.392 16C12.1513 16 11.9561 15.8049 11.9561 15.564C11.9561 15.3232 12.1513 15.128 12.392 15.128C12.6329 15.128 12.828 15.3232 12.828 15.564Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M11.0761 14.7617C11.0761 14.9109 10.9552 15.0317 10.8061 15.0317C10.6569 15.0317 10.5361 14.9109 10.5361 14.7617C10.5361 14.6127 10.6569 14.4917 10.8061 14.4917C10.9552 14.4917 11.0761 14.6127 11.0761 14.7617Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M17.418 12.0706C17.418 12.4719 17.359 12.8594 17.2483 13.2248L16.1061 12.8871C16.2038 12.5878 16.2566 12.2683 16.2566 11.9361C16.2566 11.6048 16.2041 11.2854 16.1066 10.9867C15.9136 10.3942 15.5453 9.88108 15.0631 9.50884C15.0491 9.49771 15.035 9.48709 15.0207 9.47621C14.8068 9.31395 14.5655 9.17523 14.3061 9.06865C14.139 9.00045 13.9642 8.94798 13.7846 8.90933L13.7167 8.89449L13.6485 8.88336C13.6034 8.87568 13.5565 8.86736 13.5146 8.86275L13.4501 8.85533C13.4286 8.85277 13.4088 8.84957 13.3801 8.84868L13.3018 8.84407L13.2628 8.84177L13.2427 8.84062L13.2332 8.8401L13.2286 8.83985H13.2247C12.8557 8.82833 12.4828 8.87772 12.1331 8.98982C11.7803 9.10423 11.4507 9.27621 11.1652 9.4917C10.8802 9.70783 10.6369 9.963 10.4486 10.2349C10.3996 10.302 10.3568 10.3716 10.3141 10.4404C10.2931 10.4751 10.2748 10.5101 10.2551 10.5445C10.235 10.5792 10.2172 10.6145 10.2003 10.6494C10.1282 10.7888 10.0722 10.9309 10.0244 11.0685C10.0017 11.1381 9.97818 11.2058 9.96154 11.2738C9.95322 11.3073 9.9426 11.3408 9.93569 11.3743C9.92801 11.4079 9.92085 11.4409 9.91419 11.4742C9.91074 11.4902 9.90703 11.5068 9.90383 11.5223C9.90063 11.5387 9.89807 11.5549 9.89551 11.5713C9.89039 11.6032 9.88515 11.6355 9.88003 11.6665C9.87056 11.7289 9.86569 11.7872 9.85853 11.8454C9.85341 11.9062 9.85047 11.97 9.84675 12.0289L9.8465 12.0404C9.8465 12.0404 9.8465 12.0427 9.84599 12.0427V12.0453L9.84573 12.0663C9.84522 12.0801 9.84522 12.0938 9.84458 12.107C9.84458 12.1345 9.84407 12.1608 9.84458 12.1869C9.84483 12.291 9.85008 12.3871 9.85802 12.4731C9.87376 12.6453 9.89935 12.7798 9.9188 12.8709C9.92827 12.9165 9.93569 12.9483 9.94196 12.9741C9.94798 12.9988 9.95169 13.0113 9.95169 13.0113L9.59248 13.1142C9.59248 13.1142 9.58852 13.1022 9.58071 13.0775C9.57303 13.0548 9.56011 13.0132 9.54603 12.964C9.53055 12.9089 9.51161 12.8389 9.49331 12.7552C9.45466 12.5328 9.43457 12.3043 9.43457 12.0707C9.43457 9.86613 11.2218 8.07935 13.4266 8.07935C14.4199 8.07935 15.3285 8.44225 16.0268 9.0424C16.3337 9.30614 16.6003 9.61569 16.815 9.96081C17.1972 10.5728 17.418 11.2959 17.418 12.0707L17.418 12.0706Z"
                  fill="#5F5F5F"
                />
                <path
                  d="M15.1691 10.9748C15.0995 10.8696 14.9955 10.84 14.8834 10.8948C14.7461 10.9621 14.612 11.0407 14.4826 11.1167L14.4505 11.1356C14.239 11.2603 14.0279 11.3855 13.8167 11.5108C13.6923 11.5848 13.5679 11.6587 13.4435 11.7324C13.3498 11.6903 13.2466 11.6682 13.1439 11.6682C12.9974 11.6682 12.8559 11.7121 12.7346 11.7949C12.6987 11.8196 12.6643 11.8476 12.6326 11.8788C12.3829 12.1259 12.3457 12.5161 12.544 12.8064C12.6797 13.005 12.9044 13.1238 13.1451 13.1238C13.2466 13.1238 13.3452 13.1028 13.4377 13.0621C13.4779 13.0446 13.5175 13.0226 13.5552 12.9967C13.7647 12.8537 13.8848 12.6098 13.8714 12.3573C14.0795 12.1772 14.4077 11.8998 14.6724 11.676C14.91 11.4751 15.0975 11.3165 15.1367 11.2807C15.2309 11.1941 15.2424 11.0855 15.1691 10.9748Z"
                  fill="#5F5F5F"
                />
              </svg>
              <h3>{service.steps ? service.steps.length : 0} Step</h3>
            </div>
            <div className="d-flex flex-row gap-2">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ color: "#9E9E9E" }}
              >
                <path
                  d="M8 6.66713e-05C3.58969 6.66713e-05 0 3.58974 0 8.00003C0 12.4103 3.58969 16 8 16C12.4103 16 16 12.4103 16 8.00003C16 5.24023 14.5986 2.80016 12.4661 1.36204L13.2305 0.381575L10 0.264389L10.9323 3.33339L11.6406 2.42323C13.2849 3.49817 14.4262 5.27285 14.6302 7.33467C14.46 7.34399 14.2999 7.41815 14.1826 7.5419C14.0654 7.66564 14.0001 7.82959 14 8.00003C14.0001 8.17112 14.066 8.33561 14.1841 8.45946C14.3021 8.58331 14.4632 8.65704 14.6341 8.66539C14.3229 11.8216 11.8216 14.3229 8.66537 14.6341C8.65701 14.4632 8.58328 14.3021 8.45943 14.1841C8.33558 14.066 8.17109 14.0001 8 14C7.82891 14.0001 7.66442 14.066 7.54057 14.1841C7.41672 14.3021 7.34299 14.4632 7.33464 14.6341C4.17837 14.3229 1.67714 11.8216 1.36589 8.66539C1.53677 8.65704 1.6979 8.58331 1.81593 8.45946C1.93397 8.33561 1.99987 8.17112 2 8.00003C1.99987 7.82895 1.93397 7.66446 1.81593 7.54061C1.6979 7.41676 1.53677 7.34303 1.36589 7.33467C1.69875 3.95935 4.53519 1.33339 8 1.33339C8.08834 1.33464 8.17605 1.31832 8.25803 1.28538C8.34001 1.25244 8.41462 1.20353 8.47754 1.1415C8.54045 1.07947 8.59041 1.00556 8.6245 0.924053C8.6586 0.842549 8.67616 0.75508 8.67616 0.666731C8.67616 0.578381 8.6586 0.490912 8.6245 0.409408C8.59041 0.327903 8.54045 0.253989 8.47754 0.191959C8.41462 0.12993 8.34001 0.0810228 8.25803 0.0480805C8.17605 0.0151381 8.08834 -0.00118269 8 6.66713e-05ZM7.98958 3.32427C7.813 3.32703 7.64473 3.39974 7.52169 3.52643C7.39866 3.65313 7.33092 3.82346 7.33333 4.00005V7.6667L4.93359 9.46617C4.79201 9.57219 4.69834 9.73011 4.67318 9.90519C4.64803 10.0803 4.69346 10.2582 4.79948 10.3998C4.9055 10.5413 5.06342 10.635 5.2385 10.6602C5.41358 10.6853 5.59149 10.6399 5.73307 10.5339L8.39974 8.53389C8.48265 8.47176 8.54994 8.39116 8.59628 8.2985C8.64261 8.20583 8.66671 8.10364 8.66667 8.00003V4.00005C8.66789 3.91086 8.6512 3.82233 8.61759 3.7397C8.58398 3.65707 8.53413 3.58203 8.47099 3.51902C8.40786 3.456 8.33272 3.4063 8.25003 3.37285C8.16734 3.3394 8.07877 3.32288 7.98958 3.32427Z"
                  fill="#5F5F5F"
                />
              </svg>
              <h3 style={{ color: "#9E9E9E" }}>{myservice.activeDays} Days</h3>
            </div>
            <div className="d-flex flex-row gap-2">
              {!thisPurchase && (
                <>
                  <Button
                    type="primary"
                    ghost
                    classNames="my-3"
                    loading={loading}
                    onClick={async () => {
                      setLoading(true);
                      var res = await postData(
                        `admin/service/${service.id}/purchase`,
                        { patientId: patientId }
                      );
                      if (res.status == 201) {
                        Modal.success({
                          title: "Service added successfully!",
                        });
                        navigate(
                          "/patients/" +
                            patientId +
                            "/services/in-progress/" +
                            res.data.data.id
                        );
                        // setThisPurchase(true);
                        // setService({...service,})
                        await fetchService();
                      } else {
                        Modal.error({ title: res });
                      }
                      setLoading(false);
                    }}
                  >
                    {"Add Service"}
                  </Button>
                  <div dir="rtl" style={{ width: "55%" }}>
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 11.5C22 5.70193 17.2981 1 11.5 1C5.70193 1 1 5.70193 1 11.5C1 17.2981 5.70193 22 11.5 22C17.2981 22 22 17.2981 22 11.5Z"
                        stroke="rgba(46, 108, 223, 1)"
                      />
                      <path
                        d="M14.3441 16.2188C14.2849 16.1342 14.1748 16.1003 14.0775 16.1469C13.0364 16.6378 11.8556 17.1584 11.6228 17.2049C11.6186 17.2007 11.6059 17.1922 11.5974 17.1753C11.5678 17.133 11.5509 17.0779 11.5509 17.006C11.5509 16.4177 11.9953 14.6275 12.8713 11.6862C13.612 9.21458 13.6966 8.70249 13.6966 8.5332C13.6966 8.27081 13.595 8.05074 13.4046 7.89415C13.2226 7.74602 12.9729 7.66984 12.6555 7.66984C12.1265 7.66984 11.517 7.86876 10.7891 8.28351C10.0823 8.68133 9.29091 9.35848 8.44448 10.2938C8.37677 10.3657 8.37253 10.4758 8.42755 10.5562C8.48257 10.6366 8.58837 10.6662 8.68148 10.6324C8.97773 10.5096 10.4759 9.89596 10.696 9.76053C10.8737 9.6505 11.0303 9.59125 11.1573 9.59125C11.1615 9.59125 11.1658 9.59125 11.17 9.59125C11.17 9.59971 11.1742 9.61241 11.1742 9.62934C11.1742 9.7563 11.1488 9.91289 11.0938 10.0822C9.81993 14.2128 9.19781 16.7478 9.19781 17.827C9.19781 18.2079 9.30361 18.5126 9.51099 18.737C9.72259 18.9655 10.0104 19.0798 10.3617 19.0798C10.7383 19.0798 11.1954 18.9232 11.7625 18.5973C12.3084 18.2841 13.1464 17.5943 14.3187 16.4939C14.3907 16.4177 14.4034 16.3035 14.3441 16.2188ZM14.3018 4.24602C14.0944 4.03441 13.8278 3.92438 13.5104 3.92438C13.1168 3.92438 12.7698 4.08097 12.4862 4.38992C12.2069 4.69463 12.0672 5.06283 12.0672 5.49451C12.0672 5.83308 12.173 6.11664 12.3762 6.33248C12.5835 6.55255 12.8459 6.66259 13.1591 6.66259C13.54 6.66259 13.8786 6.49753 14.1748 6.17166C14.4669 5.85001 14.615 5.47758 14.615 5.05437C14.615 4.72849 14.5092 4.45763 14.3018 4.24602Z"
                        fill="rgba(46, 108, 223, 1)"
                      />
                    </svg>
                  </div>
                </>
              )}
            </div>
          </Card>
        )}
        {isUpload ? (
          <div
            style={{
              marginLeft: "5%",
              marginTop: "30px",
              width: "88%",
              boxShadow: "0px 4px 10px 0px rgba(225, 225, 225, 0.4)",
              borderRadius: "20px",
              padding: "10px",
              boxSizing: "content-box",
            }}
          >
            <svg
              onClick={() => {
                setIsUpload(false);
              }}
              style={{
                marginTop: "10px",
                marginBottom: "-5px",
                marginLeft: "20px",
              }}
              width="24"
              height="18"
              viewBox="0 0 24 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.8016 8.39557H2.6553L10.0228 1.01421C10.2548 0.78219 10.2548 0.40603 10.0228 0.174013C9.79085 -0.0580043 9.41481 -0.0580043 9.18286 0.174013L0.783422 8.57595C0.667448 8.68473 0.601562 8.83691 0.601562 8.99605C0.601562 9.15519 0.667451 9.30737 0.783422 9.41615L9.18286 17.8181C9.2916 17.9341 9.44374 18 9.60283 18C9.76193 18 9.91406 17.9341 10.0228 17.8181C10.1388 17.7093 10.2047 17.5571 10.2047 17.398C10.2047 17.2388 10.1388 17.0867 10.0228 16.9779L2.6553 9.59653H22.8016C23.1329 9.59653 23.4016 9.32781 23.4016 8.99639C23.4016 8.66498 23.1329 8.39625 22.8016 8.39625V8.39557Z"
                fill="#18324E"
              />
            </svg>
            {/* <Documents patientId={patientId} />
             */}
            <Documents patientId={patientId} stepId={select.id} />
          </div>
        ) : isPayment ? (
          <div
            style={{
              marginLeft: "5%",
              marginTop: "30px",
              width: "88%",
              boxShadow: "0px 4px 10px 0px rgba(225, 225, 225, 0.4)",
              borderRadius: "20px",
              padding: "10px",
              boxSizing: "content-box",
            }}
          >
            <svg
              onClick={() => {
                setIsPayment(false);
              }}
              style={{
                marginTop: "10px",
                marginBottom: "-5px",
                marginLeft: "20px",
              }}
              width="24"
              height="18"
              viewBox="0 0 24 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.8016 8.39557H2.6553L10.0228 1.01421C10.2548 0.78219 10.2548 0.40603 10.0228 0.174013C9.79085 -0.0580043 9.41481 -0.0580043 9.18286 0.174013L0.783422 8.57595C0.667448 8.68473 0.601562 8.83691 0.601562 8.99605C0.601562 9.15519 0.667451 9.30737 0.783422 9.41615L9.18286 17.8181C9.2916 17.9341 9.44374 18 9.60283 18C9.76193 18 9.91406 17.9341 10.0228 17.8181C10.1388 17.7093 10.2047 17.5571 10.2047 17.398C10.2047 17.2388 10.1388 17.0867 10.0228 16.9779L2.6553 9.59653H22.8016C23.1329 9.59653 23.4016 9.32781 23.4016 8.99639C23.4016 8.66498 23.1329 8.39625 22.8016 8.39625V8.39557Z"
                fill="#18324E"
              />
            </svg>

            <Payment
              purchaseId={service.id}
              payedPrice={payedPrice}
              totalPrice={totalPrice}
            />
          </div>
        ) : (
          <>
            {!isMobile && (
              <div className="d-flex flex-row col-12 gap-1 mt-5 ">
                <div className="service-page col-12 d-flex flex-column ">
                  {isPurchase && (
                    <div
                      style={{
                        width: "95%",
                        marginTop: "-20px",
                        marginBottom: "-10px",
                      }}
                      dir="rtl"
                      className="d-flex "
                    >
                      <Button
                        className="px-1 py-1 col-2"
                        onClick={async () => {
                          await getComments();
                          setOpenComments(true);
                        }}
                        style={{
                          color: "white",
                          backgroundColor: "rgba(76, 76, 76, 1)",
                        }}
                      >
                        Comments
                      </Button>
                    </div>
                  )}

                  <h4 style={{ marginLeft: "27px" }}>Plan</h4>
                  {service.status == "cancelled" && (
                    <h5
                      style={{
                        color: "red",
                        fontWeight: "600",
                        fontSize: "16px",
                        marginLeft: "27px",
                        marginBottom: "25px",
                      }}
                    >
                      You cannot perform any actions on the service until it is
                      active.
                    </h5>
                  )}

                  {loading ? (
                    <Spin size="large" />
                  ) : (
                    <div
                      style={
                        service.status == "cancelled"
                          ? {
                              opacity: "45%",
                            }
                          : {}
                      }
                    >
                      {service.steps &&
                        service.steps.map((s, i) => {
                          if (parseInt(tempStep) == s.id) {
                            return (
                              <Step
                                step={s}
                                isFirst={i == 0}
                                isLast={i == service.steps.length - 1}
                                isPurchase={thisPurchase}
                                patientId={patientId}
                                name={name}
                                email={email}
                                serviceId={service.id}
                                fetchService={fetchType}
                                serviceName={myservice.title}
                                setSelect={setSelect}
                                setIsOpen2={setIsUpload}
                                userId={patient.userId}
                                getService={fetchType}
                                tempStep={tempStep}
                                setIsPayment={setIsPayment}
                                users={users}
                                getUsers={getUsers}
                                patient={patient}
                                openPayModal={setOpenPayModal}
                                desible={service.status == "cancelled"}
                              />
                            );
                          } else {
                            // console.log(i)
                            return (
                              <Step
                                step={s}
                                isFirst={i == 0}
                                isLast={i == service.steps.length - 1}
                                isPurchase={thisPurchase}
                                patientId={patientId}
                                name={name}
                                email={email}
                                serviceId={service.id}
                                fetchService={fetchType}
                                serviceName={myservice.title}
                                setSelect={setSelect}
                                setIsOpen2={setIsUpload}
                                userId={patient.userId}
                                getService={fetchType}
                                setIsPayment={setIsPayment}
                                users={users}
                                getUsers={getUsers}
                                patient={patient}
                                openPayModal={setOpenPayModal}
                                desible={service.status == "cancelled"}
                              />
                            );
                          }
                        })}
                    </div>
                  )}
                </div>
              </div>
            )}
            {isMobile && (
              <div
                style={{ maxWidth: "80vw" }}
                className="service-page col-12 d-flex flex-column mt-3 "
              >
                {/* <div>hnlknkjb</div> */}
                <div className="service-page mb-2">
                  <h4
                    className="col-10"
                    style={{ marginTop: "40px", display: "inline-block" }}
                  >
                    Plan
                  </h4>
                  {/* <h4
                    // className="col-10"
                    style={{ marginTop: "40px", display: "inline-block" }}
                  >
                    Plan
                  </h4> */}
                </div>
                <div
                  className={
                    isMobile
                      ? "col-12 d-flex flex-column"
                      : "col-7 d-flex flex-column"
                  }
                >
                  {loading ? (
                    <Spin size="small" />
                  ) : (
                    <div>
                      {service.steps &&
                        service.steps.map((s, i) => {
                          return (
                            <Step
                              step={s}
                              isFirst={i == 0}
                              isLast={i == service.steps.length - 1}
                              isPurchase={thisPurchase}
                              patientId={patientId}
                              name={name}
                              email={email}
                              serviceId={service.id}
                              fetchService={fetchType}
                              isEdit={isEdit}
                              needUpdate={needUpdate}
                              setNeedUpdate={setNeedUpdate}
                              setIsPayment={setIsPayment}
                              users={users}
                              getUsers={getUsers}
                              patient={patient}
                              openPayModal={setOpenPayModal}
                              desible={service.status == "cancelled"}
                            />
                          );
                        })}
                    </div>
                  )}{" "}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        open={openComments}
        footer={null}
        onCancel={() => {
          setOpenComments(false);
        }}
        width={isMobile ? "90vw" : "65vw"}
      >
        <div
          style={{ minHeight: "150px" }}
          className="d-flex flex-column gap-2"
        >
          <h2 style={{ fontSize: "22px", fontWeight: "600" }}> Comments</h2>
          <div
            style={{
              maxHeight: "78vh",
              overflowY: "scroll",
              overflowX: "hidden",
              paddingBottom: "70px",
            }}
            className="d-flex flex-column gap-1 "
          >
            {!loading && comments.length == 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "120px",
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                No Comments Found
              </div>
            )}
            {}
            {loading ? (
              <Spin size="large" />
            ) : (
              comments.map((comment) => {
                return (
                  <CommentCard
                    comment={comment}
                    getComments={getComments}
                    Users={users}
                    filter={null}
                    purchase={[
                      {
                        id: parseInt(service.id),
                        service: myservice,
                        patient: patient,
                      },
                    ]}
                    setDefult={setDefult}
                    openAddComment={setisopennewcomment}
                  />
                );
              })
            )}
          </div>
          {privilage.indexOf(access.todoList.addComment) > -1 && (
            <Button
              onClick={() => {
                setDefult({
                  patientId: patientId,
                  purchaseId: parseInt(service.id),
                  patient: patient,
                });
                setisopennewcomment(true);
              }}
              type="primary"
              size="large"
              style={
                isMobile
                  ? {
                      position: "absolute",
                      bottom: "10px",
                      right: "20px",
                      fontSize: "14px",
                    }
                  : { position: "absolute", bottom: "30px", right: "40px" }
              }
            >
              <svg
                width={isMobile ? "14" : "22"}
                height={isMobile ? "14" : "22"}
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "5px" }}
              >
                <path
                  d="M10.9745 0.576358C10.5151 0.58309 10.0771 0.771933 9.75688 1.10139C9.43662 1.43085 9.26026 1.87397 9.26655 2.33339V9.26672H2.33322C2.10353 9.26347 1.87549 9.30591 1.66234 9.39156C1.4492 9.47721 1.2552 9.60437 1.09163 9.76565C0.928051 9.92692 0.798162 10.1191 0.709506 10.331C0.62085 10.5429 0.575195 10.7703 0.575195 11.0001C0.575195 11.2298 0.62085 11.4572 0.709506 11.6691C0.798162 11.881 0.928051 12.0732 1.09163 12.2345C1.2552 12.3957 1.4492 12.5229 1.66234 12.6086C1.87549 12.6942 2.10353 12.7366 2.33322 12.7334H9.26655V19.6667C9.2633 19.8964 9.30574 20.1245 9.39139 20.3376C9.47704 20.5507 9.60419 20.7447 9.76547 20.9083C9.92675 21.0719 10.1189 21.2018 10.3308 21.2904C10.5428 21.3791 10.7702 21.4247 10.9999 21.4247C11.2296 21.4247 11.457 21.3791 11.6689 21.2904C11.8808 21.2018 12.073 21.0719 12.2343 20.9083C12.3956 20.7447 12.5227 20.5507 12.6084 20.3376C12.694 20.1245 12.7365 19.8964 12.7332 19.6667V12.7334H19.6665C19.8962 12.7366 20.1243 12.6942 20.3374 12.6086C20.5506 12.5229 20.7446 12.3957 20.9081 12.2345C21.0717 12.0732 21.2016 11.881 21.2903 11.6691C21.3789 11.4572 21.4246 11.2298 21.4246 11.0001C21.4246 10.7703 21.3789 10.5429 21.2903 10.331C21.2016 10.1191 21.0717 9.92692 20.9081 9.76565C20.7446 9.60437 20.5506 9.47721 20.3374 9.39156C20.1243 9.30591 19.8962 9.26347 19.6665 9.26672H12.7332V2.33339C12.7364 2.10163 12.693 1.87159 12.6058 1.65688C12.5185 1.44216 12.389 1.24713 12.2251 1.08331C12.0611 0.919501 11.8659 0.790233 11.6511 0.703157C11.4363 0.616081 11.2062 0.572964 10.9745 0.576358Z"
                  fill="white"
                />
              </svg>
              Comment{" "}
            </Button>
          )}
        </div>
      </Modal>
      <Modal
        open={isopennewcomment}
        onCancel={() =>
          setDefult({
            patientId: patientId,
            purchaseId: parseInt(service.id),
            patient: patient,
          })
        }
        footer={null}
        closable={false}
        width={isMobile ? "90vw" : "65vw"}
        destroyOnClose
      >
        <AddComment
          isOpen={isopennewcomment}
          getComments={getComments}
          setIsOpen={setisopennewcomment}
          patients={[patient]}
          purchase={[
            {
              id: parseInt(service.id),
              service: myservice,
              patient: patient,
            },
          ]}
          defultComment={
            defult == {}
              ? {
                  patientId: patientId,
                  purchaseId: parseInt(service.id),
                  patient: patient,
                }
              : defult
          }
          setDefult={setDefult}
        />
      </Modal>
      <Modal
        title=""
        open={isOpenAssign}
        style={{ top: "5vh" }}
        width={isMobile ? "90vw" : "65vw"}
        footer={
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              size="large"
              onClick={async () => {
                if (selectedRowKeysadmin.length == 0) {
                  setisOpenAssign(false);
                  return;
                }
                setLoading(true);
                var success = true;
                for (var row in selectedRowKeysadmin) {
                  var res = await postData("admin/user-assignment", {
                    userId: selectedRowKeysadmin[row],
                    itemType: "purchase",
                    itemId: parseInt(service.id),
                  });
                  if (res.status != 201) {
                    success = false;
                    Modal.error({ title: res });
                  }
                }
                if (success) {
                  Modal.success({ title: res.data.message });
                }
                setLoading(false);
                getAdminsOnPurchase(service.id);
                handleResetadmin(() => {});
                setisOpenAssign(false);
              }}
            >
              Assign
            </Button>
          </div>
        }
        onCancel={() => setisOpenAssign(false)}
        closeIcon={null}
        destroyOnClose
      >
        <div>
          <div style={{ textAlign: "end" }}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setisOpenAssign(false)}
              style={{ cursor: "pointer" }}
            >
              <path
                d="M9.71012 8.00014L15.6459 2.06441C16.118 1.59228 16.118 0.826413 15.6459 0.354269C15.1738 -0.11809 14.4079 -0.11809 13.9358 0.354269L7.99997 6.29025L2.06442 0.354507C1.59229 -0.117852 0.826181 -0.117852 0.354272 0.354507C-0.118091 0.826633 -0.118091 1.5925 0.354272 2.06465L6.28982 8.00014L0.354272 13.9359C-0.118091 14.408 -0.118091 15.1739 0.354272 15.646C0.590333 15.8821 0.899664 16 1.2092 16C1.51852 16 1.82811 15.8821 2.06413 15.646L7.99991 9.71052L13.9357 15.646C14.1718 15.8821 14.4815 16 14.7906 16C15.0997 16 15.4095 15.8821 15.6455 15.646C16.1177 15.1739 16.1177 14.408 15.6455 13.9359L9.71012 8.00014Z"
                fill="#4C4C4C"
              />
            </svg>
          </div>

          <div
            style={{
              textAlign: "center",
              width: "100%",
              marginTop: "-30px",
            }}
          >
            <div style={{ fontSize: "24px", fontWeight: "700" }}>
              Assign Admin
            </div>
            <hr />
          </div>
          <Table
            scroll={{ x: "auto" }}
            loading={loading}
            rowSelection={{
              type: "checkbox",
              ...rowSelectionadmin,
            }}
            columns={columns_admin}
            size="small"
            style={{ width: "100%" }}
            dataSource={data_admin}
            pagination={{
              onChange: async (page) => {
                await getAdmins(page);
              },
              pageSize: 15,
            }}
          />
        </div>
      </Modal>
      <Modal
        open={openPayModal}
        style={{ top: "5vh" }}
        width={isMobile ? "90vw" : "45vw"}
        footer={null}
        onCancel={() => {
          setShowCopyOnlinePaymentLink(false);
          setShowCopyOnlinePaymentText(false);
          setOpenPayModal(false);
        }}
        destroyOnClose
      >
        <div className="d-flex flex-column gap-4 align-items-center">
          <h2 style={{ fontSize: "20px", fontWeight: "700" }}>Payments</h2>
          <div className="payDetail d-flex flex-row gap-5  px-3 ">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              Paid ${payedPrice}
            </h4>
            <h4
              style={{
                fontSize: "14px",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              Debt ${totalPrice - payedPrice}
            </h4>
            <h4
              style={{
                fontSize: "14px",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              Total ${totalPrice}
            </h4>
          </div>
          <div className="h-line" />
          <div className="paySteps d-flex flex-column gap-3 col-9">
            {payments.map((p) => {
              return payment(
                p,
                selectedPayments.indexOf(p),
                setSelectedPayments,
                selectedPayments
              );
            })}
          </div>
          {selectedPayments.length > 0 && (
            <div className="d-flex flex-column gap-2 col-10">
              <h4
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "18px",
                  paddingLeft: "25px",
                  paddingRight: "20px",
                }}
              >
                Which type of payment you prefer?{" "}
              </h4>
              <CustomInput
                additionalClassNames="payMethode col-12 px-4"
                select
                options={paymentOptions.map((p) => {
                  return p.value;
                })}
                onChange={(v) => {
                  var temp = paymentOptions.filter((p) => {
                    return p.value == v;
                  });
                  if (temp.length > 0) setPaymentType(temp[0].key);
                }}
              />
            </div>
          )}
          <h4
            style={{
              fontSize: "14px",
              color: "rgba(39, 155, 214, 1)",
              textAlign: "right",
              display: "flex",
              justifyContent: "end",
            }}
            className="w-100"
          >
            Selected payments:
            <div style={{ fontWeight: "bold" }}>{"$" + getSelected()}</div>
          </h4>
          {selectedPayments.length > 0 && (
            <div
              className="d-flex flex-row gap-2 col-12"
              style={{ justifyContent: "space-between" }}
            >
              <div className="d-flex flex-column col-8 gap-1">
                {paymentType == "E-transfer" && (
                  <>
                    <h5
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        textAlign: "left",
                      }}
                    >
                      Please transfer to payment@allbrainsclinic.com
                    </h5>
                    <h5
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        textAlign: "left",
                      }}
                    >
                      Tap Confirm Button to confirm payment type.
                    </h5>
                  </>
                )}
              </div>

              {showCopyOnlinePaymentLink ? (
                <Button
                  onClick={() => {
                    console.log(onlinePaymentLink);
                    navigator.clipboard.writeText(onlinePaymentLink);
                    setShowCopyOnlinePaymentText(true);
                  }}
                >
                  {!showCopyOnlinePaymentText ? "Copy Link" : "Copied"}
                </Button>
              ) : (
                <></>
              )}
              <Button
                loading={loading}
                type="primary"
                onClick={async () => {
                  await chekout();
                }}
              >
                Confirm
              </Button>
            </div>
          )}
        </div>
      </Modal>
      <Modal
        visible={isModalVisible}
        onOk={() => {
          setIsModalVisible(false);
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        closeIcon={null}
      >
        <p style={{ fontWeight: "700" }}>
          {modalData?.message || "Something went wrong!"}
        </p>
      </Modal>
    </div>
  );
};
const payment = (p, isSelected, setSelectedPayments, selectedPayments) => {
  return (
    <div
      style={
        p.status == "done"
          ? {
              minHeight: "60px",
              width: "100%",
              backgroundColor: "rgba(249, 254, 244, 1)",
              boxShadow: "0px 0px 10px 0px rgba(225, 225, 225, 0.7)",
              borderRadius: "4px",
              border: "1px solid rgba(225, 225, 225, 0.7)",
            }
          : isSelected != -1
          ? {
              minHeight: "60px",
              width: "100%",
              backgroundColor: "rgba(39, 155, 214, 0.08)",
              boxShadow: "0px 0px 10px 0px rgba(225, 225, 225, 0.7)",
              borderRadius: "4px",
              border: "1px solid rgba(225, 225, 225, 0.7)",
            }
          : {
              minHeight: "60px",
              width: "100%",
              backgroundColor: "rgba(255, 255, 255, 1)",
              boxShadow: "0px 0px 10px 0px rgba(225, 225, 225, 0.7)",
              borderRadius: "4px",
            }
      }
      className="d-flex flex-row align-items-center gap-3 px-3"
    >
      <input
        disabled={p.status == "done"}
        style={
          isSelected != -1
            ? { backgroundColor: "rgba(39, 155, 214, 1)" }
            : p.status == "done"
            ? { backgroundColor: "rgba(129, 192, 71, 1)" }
            : {}
        }
        // value={isSelected}
        type="checkbox"
        checked={isSelected != -1}
        onChange={(v) => {
          if (v.target.checked) {
            setSelectedPayments([...selectedPayments, p]);
          } else {
            setSelectedPayments(
              selectedPayments.filter((pay) => {
                return pay.id != p.id;
              })
            );
          }
        }}
      />
      <h4 className="col-4">{p.title}</h4>
      <div className="v-line" style={{ height: "100%" }} />
      <div
        style={{ marginLeft: "20px", alignItems: "center" }}
        className="d-flex flex-row gap-1"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <path
            d="M8.5 1C4.35938 1 1 4.35938 1 8.5C1 12.6406 4.35938 16 8.5 16C12.6406 16 16 12.6406 16 8.5C16 4.35938 12.6406 1 8.5 1ZM8.5 1.83333C12.1914 1.83333 15.1667 4.80859 15.1667 8.5C15.1667 12.1914 12.1914 15.1667 8.5 15.1667C4.80859 15.1667 1.83333 12.1914 1.83333 8.5C1.83333 4.80859 4.80859 1.83333 8.5 1.83333ZM8.08333 3.91667V4.82812C7.41602 4.91113 6.20833 5.49544 6.20833 6.91146C6.20833 9.57747 10.0885 8.2054 10.0885 10.2057C10.0885 10.873 9.79232 11.4948 8.5 11.4948C7.20768 11.4948 6.83333 10.5003 6.83333 9.95833H6C6.12533 11.7503 7.37533 12.1637 8.08333 12.2891V13.0833H8.91667V12.2891C9.54167 12.2467 11 11.7943 11 10.1276C11 8.75228 9.87044 8.37305 8.78646 8.1224C7.91081 7.91406 7.11979 7.70898 7.11979 6.83333C7.11979 6.45898 7.28906 5.6224 8.53906 5.6224C9.41471 5.6224 9.83301 6.16602 9.95833 6.83333H10.7917C10.541 5.91699 10.1243 5.08854 8.91667 4.88021V3.91667H8.08333Z"
            fill="#18324E"
            stroke="#18324E"
            stroke-width="0.5"
          />
        </svg>
        <div
          style={{
            color: "#18324E",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          {p.price}
        </div>
      </div>
    </div>
  );
};
export default ServicePage;
